module.exports = __webpack_public_path__ + "media/packs/images/cost/container-f2be4c1131cfa1e7e9fe4f89c0971354.svg";